// Complete a Firestore REST collection read or fail; never return a successful
// partial ledger when a later page fails. Tokens are opaque and stay on the
// original collection URL with the original authenticated headers.
export async function readCollectionPages(first: Response, url: string, headers: HeadersInit) {
  let response = first;
  const documents: any[] = [];
  const seen = new Set<string>();
  for (;;) {
    if (!response.ok) throw new Error(`Firestore collection page failed: ${response.status}`);
    const page = await response.json();
    if (page.documents !== undefined && !Array.isArray(page.documents)) throw new Error('Invalid collection page');
    documents.push(...(page.documents || []));
    const token = page.nextPageToken;
    if (!token) return { documents };
    if (typeof token !== 'string' || seen.has(token)) throw new Error('Invalid or repeated collection cursor');
    seen.add(token);
    const next = new URL(url);
    next.searchParams.set('pageToken', token);
    response = await fetch(next.toString(), {method:'GET',headers});
  }
}
